import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { withDefaults } from 'vue'

interface Props {
  visible: boolean
  centered?: boolean
  title?: string
  subtitle?: string
  okText?: string
  cancelText?: string
  contain?: string
  showIcon?: boolean
  isLoading?: boolean
  preffix?: string
  isShowCancelBtn?: boolean
  isShowOkBtn?: boolean
  btnType?: boolean
  disabledOkBtn?: boolean
  containStyle?: Record<string, string | number>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'g-base-modal',
  props: {
    visible: { type: Boolean, default: false },
    centered: { type: Boolean, default: true },
    title: { default: 'common.warmTip' },
    subtitle: null,
    okText: { default: 'materialPage.delete.confirm' },
    cancelText: { default: 'common.cancel' },
    contain: { default: 'materialPage.delete.tip' },
    showIcon: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    preffix: { default: '' },
    isShowCancelBtn: { type: Boolean, default: true },
    isShowOkBtn: { type: Boolean, default: true },
    btnType: { type: Boolean, default: false },
    disabledOkBtn: { type: Boolean, default: false },
    containStyle: { default: () => ({
    marginLeft: '28px',
  }) }
  },
  emits: ['ok', 'cancel'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, centered: boolean, title: string, subtitle?: string, okText: string, cancelText: string, contain: string, showIcon: boolean, isLoading: boolean, preffix: string, isShowCancelBtn: boolean, isShowOkBtn: boolean, btnType: boolean, disabledOkBtn: boolean, containStyle: Record<string, string | number> }




function translateLang(key: string): string {
  return translate(key)
}

function handleOk() {
  emits('ok')
}

function handleCancel(type: string) {
  emits('cancel', { cancelType: type })
}

function getPreffix() {
  return props.preffix ? props.preffix + '_' : ''
}

return { __sfc: true,props, emits, translateLang, handleOk, handleCancel, getPreffix }
}

})